module.exports = __webpack_public_path__ + "static/media/vials-animation.2d8f0cf7.svg";